export default defineNuxtRouteMiddleware(async (to) => {
    const decathStore = useDecathlonStores()
    const userStore = useUserStore()
    const languageStore = useLanguageStore()

    if (languageStore.languages?.length == 0) {
        await languageStore.fetchAllLanguages()
    }

    await languageStore.migrateIfNeeded()

    if (to.fullPath.startsWith("/admin") && !userStore.isAdmin) {
        return '/store'
    }

    // ⛔ Empêche les redirections si on est déjà sur ces pages
    const exemptRoutes = ['/welcome', '/choose-diag', '/admin/choose-diag']
    if (exemptRoutes.includes(to.fullPath)) {
        return
    }

    // 🏬 Store obligatoire
    if (!decathStore.selectedStore) {
        return '/welcome'
    }

    if (!decathStore.selectedCrossDiag) {
        return '/choose-diag'
    }

    if (decathStore.crossDiagGroups?.length == 0) {
        await decathStore.fetchCrossDiagGroups()
    }

    // 🏁 Redirection par défaut
    if (to.fullPath === '/' || to.matched.length == 0) {
        return '/store'
    }
})
